import * as Toolkit from '../../../toolkit/index';
import FrontCubeData from '../../../frontCubeData/index';

function setTitleStyle(cube: CubeNode): void {
    let shelfId: string = FrontCubeData.getValue(cube.id, 'shelfId');
    let displayUnit: string = FrontCubeData.getValue(cube.id, 'displayUnit');
    let freezerTitle: string = `${shelfId} ${displayUnit}`;
    let height: LogicsicsMeasurement = FrontCubeData.getLogicValue(cube.id, 'depth') || 300;

    Toolkit.html(cube.jView.find('.J_FreezerId'), freezerTitle);
    cube.jView.find('.shelves-freezer-title')
        .css('bottom', height + 20);
}

export {
    setTitleStyle
};
